import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessAccount } from 'src/app/shared/models/business-account.model';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})

export class BusinessAccountService {
	private apiUrl = environment.apiUrl;
	private apiUrl1 = environment.apiUrl1;

	constructor(private http: HttpClient) { }

	getAll() {
		return this.http.get<BusinessAccount[]>(`${this.apiUrl1}/api/business-account`);
	}

	getAllDetails():Observable<any> {
		return this.http.get<BusinessAccount[]>(`${this.apiUrl1}/api/business-account/details`);
	}

	getbusinessaccountsWithTrashed() {
		return this.http.get<BusinessAccount[]>(`${this.apiUrl}/api/businessaccounts/withtrashed`);
	}

	getById(id: number) {
		return this.http.get(`${this.apiUrl}/api/businessaccounts/${id}`);
	}

	create(businessaccount: BusinessAccount) {
		return this.http.post(`${this.apiUrl}/api/businessaccounts`, businessaccount);
	}

	update(businessaccount: BusinessAccount) {
		return this.http.put(`${this.apiUrl}/api/businessaccounts/${businessaccount.id}`, businessaccount);
	}

	delete(id: number, params: any) {
		return this.http.post(`${this.apiUrl}/api/businessaccounts/delete/${id}`, params);
	}

	setActiveDeactiveUser(businessaccount: BusinessAccount) {
		return this.http.put(`${this.apiUrl}/api/businessaccounts/status-change/${businessaccount.id}`, businessaccount);
	}

	sendInviteUserMail(id) {
		return this.http.get(`${this.apiUrl}/api/users/invite/${id}`);
	}
	//getAllBusinessAccountList
	getBusinessAccountList()
	{
		return this.http.get(`${this.apiUrl1}/api/business-account/details`);
	}
	getBusinessAccountListById(id:number)
	{
		return this.http.get(`${this.apiUrl1}/api/business-account/details/${id}`);
	}

	AddBusinessAccount(businessaccount: any) {
		return this.http.post(`${this.apiUrl1}/api/businessnetwork`, businessaccount);
	}

	verifyBusinessName(name : any){
		return this.http.post(`${this.apiUrl1}/api/business-account/verify/business-name` ,{ businessName:name});
	}

	getMyConnection() {
		return this.http.get(`${this.apiUrl1}/api/businessnetwork/connections/accepted`);
	}
}
